import { render } from "./ProjetArbreDeVie.vue?vue&type=template&id=6a4d6f10&scoped=true"
import script from "./ProjetArbreDeVie.vue?vue&type=script&lang=js"
export * from "./ProjetArbreDeVie.vue?vue&type=script&lang=js"

import "./ProjetArbreDeVie.vue?vue&type=style&index=0&id=6a4d6f10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4d6f10"]])

export default __exports__